module.exports = [{"Name":"Recommended"},{"Name":"Indigenous"},{"Name":"Eco-Friendly"}]


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/static/hotel-tags.json
// module id = 324
// module chunks = 0